import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { finalize, catchError } from 'rxjs/operators';

import { LoaderService } from './services/loader.service';
import AppConstants from './constants/AppConstants';
import { of } from 'rxjs/observable/of';
import {environment} from '../environments/environment';

@Injectable()
export class AppInterceptor implements HttpInterceptor {

  private static requestCounter: number = 0;
  constructor(private loaderService: LoaderService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Adding token to all the request
    if (request.url.indexOf(environment.server) >= 0) {
      let token = localStorage.getItem('token');
      if (token) {
        token = atob(token);
        request = request.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`
          }
        });
      }
    }
    if (request.body) {
      const index = AppConstants.enableLoaderException.indexOf(request.body.operationName);
      if (index >= 0 || (request.body.query && request.body.query.indexOf('mutation') === -1)) {
        this.loaderService.show();
      } else if (!request.body.query) {
        this.loaderService.show();
      }
    }
    AppInterceptor.requestCounter++;
    return next.handle(request).pipe(
      finalize(() => {
        AppInterceptor.requestCounter--;
        if (AppInterceptor.requestCounter === 0) {
          this.loaderService.hide();
        }
      }),
      catchError((error, caught) => {
        AppInterceptor.requestCounter--;
        if (AppInterceptor.requestCounter === 0) {
          this.loaderService.hide();
        }
        if (error.error && error.error.name === 'TokenExpiredError') {
          localStorage.removeItem('token');
          return of(error.error);
        }
      }) as any
    );
  }
}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/app.interceptor.ts